import { Fingerprint, Home, Mail, Send, ShieldCheck } from "lucide-react";
import { useState, type FormEvent } from "react";
import { authClient } from "../auth-client";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "sent" | "passkey" | "error">("idle");

  async function sendLink(event: FormEvent) {
    event.preventDefault();
    setStatus("sending");
    const result = await authClient.signIn.magicLink({
      email,
      callbackURL: window.location.origin,
      errorCallbackURL: `${window.location.origin}/?auth=error`,
    });
    setStatus(result.error ? "error" : "sent");
  }

  async function usePasskey() {
    setStatus("passkey");
    const result = await authClient.signIn.passkey({ autoFill: false });
    if (result.error) {
      setStatus("error");
      return;
    }
    window.location.reload();
  }

  return (
    <main className="login-page">
      <section className="login-panel" aria-labelledby="login-title">
        <div className="login-brand"><img src="/fam-mark.svg" alt="" /><span>Fam</span></div>
        <span className="eyebrow">Chomout Family OS</span>
        <h1 id="login-title">Welcome home.</h1>
        <p>Sign in with an invited email address or a passkey registered to this device.</p>

        <form onSubmit={sendLink}>
          <label htmlFor="login-email">Email</label>
          <div className="email-field"><Mail size={18} /><input id="login-email" type="email" required autoComplete="username webauthn" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="you@example.com" /></div>
          <button className="primary-button" type="submit" disabled={status === "sending" || status === "sent"}><Send size={17} /> {status === "sending" ? "Sending" : status === "sent" ? "Check your email" : "Email me a sign-in link"}</button>
        </form>

        <div className="login-divider"><span>or</span></div>
        <button className="passkey-button" type="button" onClick={() => void usePasskey()} disabled={status === "passkey"}><Fingerprint size={20} /> {status === "passkey" ? "Waiting for passkey" : "Use a passkey"}</button>
        {status === "error" ? <p className="login-error" role="alert">Sign-in could not be completed. Check the address or try again.</p> : null}
        <div className="login-trust"><ShieldCheck size={16} /><span>Invite-only. Private records stay private.</span></div>
      </section>
      <aside className="login-context" aria-label="Household sign-in context">
        <Home size={28} />
        <blockquote>“Know what matters today, who owns the next step, and where it came from.”</blockquote>
        <span>Chomout household</span>
      </aside>
    </main>
  );
}

